import { Alert } from 'antd';
import './AlertComponent.scss';

interface AlertComponentProps {
  value: string;
}

const NoAlert = 'Sin alerta';
const ProaxisAlert = 'Proaxis';
const TimeUseLimitAlert = 'Limite tiempo uso';
const CommunicationErrorAlert = 'Error comunicación';
const HighPressureAlert = 'Presión alta';

const AlertComponent = ({ value }: AlertComponentProps) => {
  switch (value) {
    case NoAlert:
      return <Alert message={value} type="success" showIcon />;
    case ProaxisAlert:
    case TimeUseLimitAlert:
    case CommunicationErrorAlert:
    case HighPressureAlert:
      return <Alert message={value} type="error" showIcon />;
    default:
      return <Alert message={'No info'} type="info" showIcon />;
  }
};

export default AlertComponent;
